import LitigationFinanceGuide from './LitigationFinanceGuide';

export default LitigationFinanceGuide;
